var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.233,
    cy: 68.329,
    r: 55.671,
    fill: "#F1F3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.672,
    cy: 21.857,
    r: 3.489,
    fill: "#F1F3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.747,
    cy: 6.503,
    r: 6.503,
    fill: "#F1F3FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.161,
    cy: 104.174,
    r: 6.186,
    fill: "#F1F3FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.021,
    cy: 84.854,
    r: 1.745,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.523 21.393c-.183-.039-.183-.301 0-.34l2.781-.591a.174.174 0 00.134-.134l.599-2.76c.04-.184.3-.184.34 0l.599 2.76c.014.067.067.12.134.134l2.78.59c.184.04.184.302 0 .341l-2.78.592a.174.174 0 00-.134.133l-.599 2.761c-.04.183-.3.183-.34 0l-.599-2.76a.174.174 0 00-.134-.134l-2.78-.591zM110.086 101.241c.064-.302.495-.302.559 0l.954 4.506c.023.11.108.196.218.22l4.46.972c.3.065.3.492 0 .557l-4.46.972a.284.284 0 00-.218.22l-.954 4.506c-.064.302-.495.302-.559 0l-.954-4.506a.284.284 0 00-.218-.22l-4.46-.972c-.3-.065-.3-.492 0-.557l4.46-.972a.284.284 0 00.218-.22l.954-4.506zM47.447 19.414c.049-.233.38-.233.43 0l.428 2.024a.22.22 0 00.169.17l2.009.437c.23.05.23.38 0 .43l-2.01.437a.22.22 0 00-.168.17l-.428 2.024c-.05.232-.381.232-.43 0l-.429-2.025a.22.22 0 00-.168-.169l-2.01-.438c-.23-.05-.23-.379 0-.429l2.01-.438a.22.22 0 00.168-.169l.429-2.024z",
    fill: "#C4CBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.689 85.719c7.142-2.047 3.027-.589 7.184-2.154 3.14-1.846 6.38-3.547 10.212-4.41 3.255-.733 3.175-.64 6.74-.465 1.701.524 3.11 1.666 3.373 3.007.218 1.108-2.014 2.747-3.374 3.351-5.081 2.258-2.604 1.072-6.318 2.105-6.898 1.917-14.32 5.197-17.219 10.3-1.572 2.768-1.954 5.986-.578 8.533 1.926 3.566 7.833 6.531 13.699 6.019 2.352-.205 5.091-.652 7.349-1.351 2.386-.738 3.949-1.31 6.009-2.456 4.779-2.659 10.474-6.114 15.13-8.881",
    stroke: "#C4CBF5",
    strokeWidth: 1.161,
    strokeLinecap: "round",
    strokeDasharray: "2.77 2.77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.175 49.677c1.69-18.45-11.896-34.775-30.345-36.465-18.45-1.69-34.775 11.896-36.465 30.345-.38 4.141.011 8.176 1.054 11.963 1.72 8.474 6.42 17.3 11.415 24.821 5.004 7.536 10.336 13.81 13.354 17.175 1.601 1.785 4.254 2.014 6.148.553 3.96-3.056 11.34-9.088 18.232-16.562 6.875-7.454 13.331-16.412 15.362-25.33a33.718 33.718 0 001.245-6.5z",
    fill: "url(#noAddress_svg__paint0_linear_397_24116)",
    stroke: "#C4CBF5",
    strokeWidth: 1.161
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.853 47.816c.662-7.226-4.659-13.62-11.885-14.282-7.225-.662-13.62 4.66-14.282 11.885-.661 7.226 4.66 13.62 11.885 14.282 7.226.662 13.62-4.66 14.282-11.885z",
    fill: "#fff",
    stroke: "#C4CBF5",
    strokeWidth: 1.161
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.238 58.801v.02l.003.022c.379 3.667-.933 8.023-2.687 11.965-1.745 3.923-3.885 7.343-5.06 9.109a1.05 1.05 0 01-1.405.34c-1.669-.94-4.66-2.733-7.684-5.072-3.035-2.346-6.055-5.206-7.834-8.27l-.011-.019-.013-.018a13.478 13.478 0 01-1.95-4.434c-1.738-7.256 2.736-14.547 9.992-16.284 7.256-1.738 14.546 2.736 16.284 9.992.212.887.331 1.773.365 2.65z",
    fill: "#C4CBF5",
    stroke: "#C4CBF5",
    strokeWidth: 1.269
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.591 57.896A6.022 6.022 0 1011.879 60.7a6.022 6.022 0 0011.713-2.804z",
    fill: "#fff",
    stroke: "#C4CBF5",
    strokeWidth: 1.269
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "noAddress_svg__paint0_linear_397_24116",
    x1: 86.777,
    y1: 13.79,
    x2: 78.902,
    y2: 99.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#C4CBF5"
  })))));
}
export default SvgNoAddress;